export default {
  addPanel: 'Add Panel',
};
